<template>
  <img :src="iconSrc" :style="style" />
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  determination: {
    type: String,
    default: '',
  },
  size: {
    type: [Number, String],
    default: null,
  },
  truncated: {
    type: Boolean,
    default: false,
  },
})

const iconSrc = computed(() => {
  if (props.truncated) {
    return '/gfx/worker-classification-icon-indigo.svg'
  }

  return props.determination === 'ir35'
    ? '/gfx/ir35-logo-indigo.svg'
    : '/gfx/worker-classification-logo-indigo.svg'
})

const style = computed(() => {
  if (props.size === null) {
    return {}
  }
  return {
    height: 'auto',
    maxWidth: `${props.size}px`,
  }
})
</script>
